import React, { useEffect, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";

interface SignatureModalProps {
  confirmAction: (signatureDataUrl: string) => void;
  setOpen: (state: { open: boolean }) => void;
  title: string;
  savedSignature: string;
}

export default function SignatureModal({
  confirmAction,
  setOpen,
  title,
  savedSignature,
}: SignatureModalProps) {
  const sigCanvas = useRef<SignatureCanvas | null>(null);

  const saveSignature = () => {
    if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
      const trimmedCanvas = sigCanvas.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      confirmAction(trimmedCanvas);
    }
  };

  useEffect(() => {
    if (sigCanvas.current && savedSignature) {
      sigCanvas.current.fromDataURL(savedSignature);
    }
  }, [savedSignature]);

  return (
    <div className="justify-between">
      <div>
        <div className="flex items-center justify-between flex-wrap sm:flex-nowrap">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              {title}
            </h3>
          </div>
        </div>

        <div className="py-1 gap-4 bg-white sm:rounded-xl">
          <div className="grid grid-cols-1 gap-4 w-full border-2 border-solid">
            <SignatureCanvas
              ref={sigCanvas}
              penColor="green"
              canvasProps={{
                width: 500,
                height: 200,
                className: "sigCanvas",
              }}
            />
          </div>

          <div className="sm:flex-no-wrap my-auto flex items-center">
            <button
              onClick={() => {
                saveSignature();
                setOpen({ open: false });
              }}
              className="inline-flex justify-center mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-main-purple hover:bg-indigo-700 items-center"
            >
              OK
            </button>
            <button
              onClick={() => setOpen({ open: false })}
              className="ml-2 inline-flex justify-center mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 items-center"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                sigCanvas.current?.clear();
              }}
              className="ml-2 inline-flex justify-center mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-yellow-600 hover:bg-yellow-700 items-center float-right"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
